import { Pow18 } from 'config'
import { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import {
  updateCreateOrderOption,
  updateLastInputAmountType,
} from 'store/spot/actions'
import { useCurrentSpotSymbol } from 'store/spot/hooks'
import { LastInputAmountType } from 'store/spot/types'
import { Ether } from 'types'
import { e2w, toFixed, w2e } from 'utils/number'
import { orderPercentAtom } from '../../views/Spot/CreateOrder/AmountPercent/atoms'
import { useSetAtom } from 'jotai'

export const useBaseCurrencyAmountCallback = () => {
  const dispatch = useDispatch()
  const { id = 0, baseScale = 0, quoteScale = 0 } = useCurrentSpotSymbol()
  const setOrderPercent = useSetAtom(orderPercentAtom)

  return useMemo(() => {
    return {
      onBaseCurrencyAmountInput: (
        amount: Ether,
        price: Ether,
        percent?: boolean
      ) => {
        try {
          if (+amount < 0) return
          dispatch(updateLastInputAmountType(LastInputAmountType.BaseCurrency))
          dispatch(
            updateCreateOrderOption({
              option: 'baseCurrencyAmount',
              value: toFixed(amount, baseScale),
            })
          )
          if (!id) {
            return
          }
          if (amount) {
            let safePrice = toFixed(price, quoteScale)
            if (safePrice) {
              const quoteWei = e2w(amount).mul(e2w(safePrice)).div(Pow18)
              dispatch(
                updateCreateOrderOption({
                  option: 'quoteCurrencyAmount',
                  value: toFixed(w2e(quoteWei), quoteScale),
                })
              )
            }
          } else {
            dispatch(
              updateCreateOrderOption({
                option: 'quoteCurrencyAmount',
                value: '',
              })
            )
          }

          // If the amount is not set from the percent button, reset the percent to 0
          if (!percent) {
            setOrderPercent(0)
          }
        } catch (error) {
          console.error(error)
        }
      },
    }
  }, [id])
}
